// Navigation constants - centralized navigation data
// This file can be imported wherever navigation structure is needed

import { GENIUS_SECTION_IDS } from "./sectionIds";

export interface SubNavItem {
  id: string;
  label: string;
  href: string;
  description?: string;
}

export interface NavItem {
  id: string;
  label: string;
  href: string;
  /** Scroll to this section id instead of routing (when element exists on page). */
  scrollTarget?: string;
  hasSubMenu?: boolean;
  subItems?: SubNavItem[];
  icon?: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    id: "home",
    label: "Home",
    href: "/home"
  },
  {
    id: "olympiad",
    label: "Olympiad",
    href: "/olympiad",
    hasSubMenu: true,
    subItems: [
      {
        id: "score",
        label: "SCORE",
        href: "/olympiad/score",
      },
      {
        id: "math-olympiad",
        label: "Math Olympiad",
        href: "/olympiad/math",
      },
      {
        id: "hots-olympiad",
        label: "HOTS Olympiad",
        href: "/olympiad/hots",
      },
    ],
  },
  {
    id: "testimonials",
    label: "Testimonials",
    href: "#testimonials",
    scrollTarget: GENIUS_SECTION_IDS.STORIES
  },
  {
    id: "how-it-works",
    label: "How it works?",
    href: "#how-it-works",
    scrollTarget: GENIUS_SECTION_IDS.JOURNEY
  },
  {
    id: "about",
    label: "About Infinity Learn",
    href: "/about",
  },
];

// Helper functions for navigation
export const getNavItemById = (id: string): NavItem | undefined => {
  return NAV_ITEMS.find((item) => item.id === id);
};

export const getNavItemByPath = (path: string): NavItem | undefined => {
  return NAV_ITEMS.find((item) => {
    if (item.href === path) return true;
    if (item.subItems) {
      return item.subItems.some((subItem) => subItem.href === path);
    }
    return false;
  });
};

export const isPathActive = (item: NavItem, currentPath: string): boolean => {
  if (currentPath === item.href) return true;
  if (item.subItems) {
    return item.subItems.some((subItem) => currentPath === subItem.href);
  }
  return false;
};

// Navigation route constants (mounted inside inmobius at /home)
export const ROUTES = {
  HOME: "/home",
  SCHOOL_LOGIN: "/school-login",
  SCHOOL_REGISTER: "/school-register",
  OLYMPIAD: "/olympiad",
  OLYMPIAD_SCORE: "/olympiad/score",
  OLYMPIAD_MATH: "/olympiad/math",
  OLYMPIAD_HOTS: "/olympiad/hots",
  TESTIMONIALS: "/testimonials",
  HOW_IT_WORKS: "/how-it-works",
  ABOUT: "/about",
  CHAMPIONS: "/champions"
} as const;

export type RouteType = (typeof ROUTES)[keyof typeof ROUTES];
